import {
  useAppContext 
} from "@/context/app"
import {
  useCallback 
} from "react"

export const SHIMMER_TYPE_SUFFIX = "_SHIMMER"

export const useInternalLink = (rootType) => {
  const [, appApi] = useAppContext()
  const {
    actions: appActions 
  } = appApi
  const {
    setNextRootComponent 
  } = appActions

  const type = `${rootType.toUpperCase()}${SHIMMER_TYPE_SUFFIX}`

  const setShimmerType = useCallback(() => {
    globalThis.avoidDelayedTransition = true
    setNextRootComponent(type)
  }, [setNextRootComponent, type])

  return {
    setShimmerType,
  }
}
